var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-list-item",class:{
	'disabled': _vm.disabled,
	'has-dropdown': _vm.hasDropdown,
	'on-right': _vm.isOnRight
},on:{"click":_vm.click,"mouseleave":function($event){return _vm.unhover()},"mouseenter":function($event){return _vm.hover()}}},[_c('SvgIcon',{attrs:{"name":_vm.icon}}),_vm._t("default"),(_vm.hasDropdown)?_c('div',{staticClass:"arrow"},[_c('SvgIcon',{attrs:{"name":"submenu"}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }